import { render } from "./a-collapse-header.vue?vue&type=template&id=8789b4f8"
import script from "./a-collapse-header.vue?vue&type=script&lang=js"
export * from "./a-collapse-header.vue?vue&type=script&lang=js"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/projects-manager/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__